export const NODE_ENV = `${import.meta.env.MODE}`

export const MERCURE_URL =
  window.lingokingConfig.API_URL + '/' + window.lingokingConfig.MERCURE_URL_PREFIX

export const SHOP_URL = window.lingokingConfig.SHOP_URL
export const CUSTOMER_AREA_URL = window.lingokingConfig.CUSTOMERAREA_URL

export const POSTHOG_HOST = window.lingokingConfig.POSTHOG_HOST
export const POSTHOG_ID = window.lingokingConfig.POSTHOG_ID

export const FRIENDLY_CAPTCHA_SITEKEY = window.lingokingConfig.FRIENDLY_CAPTCHA_SITEKEY
export const FRIENDLY_CAPTCHA_PUZZLE_ENDPOINT =
  window.lingokingConfig.FRIENDLY_CAPTCHA_PUZZLE_ENDPOINT
export const CAPTCHA_DISABLED = window.lingokingConfig.CAPTCHA_DISABLED
export const INTERCOM_APP_ID = window.lingokingConfig.INTERCOM_APP_ID
